module.exports = __webpack_public_path__ + "static/brno-2025-b07014b815af0e3317909cae759e9a0b.jpg";